import { Component, input, OnInit, output } from '@angular/core';
import { ContractComponent } from '../contract/contract.component';
import { ContractPriceGroupComponent } from '../contract-price-group/contract-price-group.component';
import { I18nModule } from '@spartacus/core';
import { PriceChannel } from '../../model/price-channel.model';
import { ContractConditions, ContractControls } from '../../model/contract-conditions.model';
import { PriceGroup } from '../../model/price-group.model';

@Component({
  selector: 'app-contracts-partial',
  imports: [
    ContractComponent,
    ContractPriceGroupComponent,
    I18nModule
  ],
  templateUrl: './contracts-partial.component.html'
})
export class ContractsPartialComponent implements OnInit {

  protected readonly PriceChannel = PriceChannel;
  conditions = input.required<ContractConditions[]>();
  selectedChannel = input.required<PriceChannel>();
  hasMatchingContract = input.required<boolean>();
  showPriceGroup = input.required<boolean>();
  priceGroupToShow = input.required<PriceGroup[]>();
  contractFromCartApi = input.required<string>();
  rowView = input<boolean>(false);

  selectPriceGroup = output<ContractControls>();
  selectedContract = output<ContractControls>();

  contractSelected: ContractConditions;
  contractSelectedId: string;

  ngOnInit(): void {
    if (this.conditions().length === 1 && !this.contractFromCartApi()) {
      this.showSelectedContract(this.conditions()[0]);
    }
  }

  showSelectedContract(contract: ContractConditions): void {
    this.contractSelectedId = contract?.contractId;
    this.contractSelected = contract;

    const contractsInfo = {
      contractSelected: contract
    };

    if (contract && contract?.priceGroups?.length === 1) {
      this.selectedContract.emit({
        enableBtn: true,
        priceToShow: contract?.priceGroups[0]?.priceData?.value,
        priceToShowGroupId: contract?.priceGroups[0]?.groupId,
        ...contractsInfo
      });
    } else {
      this.selectedContract.emit({
        enableBtn: false,
        priceToShow: null,
        priceToShowGroupId: null,
        priceGroupToShow: contract?.priceGroups,
        ...contractsInfo
      });
    }
  }

  showSelectPriceGroup(priceGroup: PriceGroup): void {
    this.selectPriceGroup.emit({
      enableBtn: true,
      priceToShow: priceGroup?.priceData?.value,
      priceToShowGroupId: priceGroup?.groupId
    });
  }

  get selectedContractName(): string {
    if (!this.conditions()?.length) {
      return '';
    }

    return this.conditions().find(condition => condition.contractId === this.contractFromCartApi())?.contractName || '';
  }
}
